import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";

import { useEffectOnMount } from "@/domains/react/useEffectOnMount";

export const RedirectToActiveOrNewSession = observer(function RedirectToActiveOrNewSession() {
  const { store, pageStore } = useAppStore();

  useEffectOnMount(() => {
    const autoRouteToSession = async () => {
      let sessionId = await pageStore.memItPage.resumeActiveSession();

      // If we couldn't snap to the most recent session, then we want to get a new one
      if (!sessionId) {
        sessionId = await store.sessions.getLatestInitialChatSession();
      }

      store.sidePanel.goToMemIt(sessionId, { openChatPanel: false });
    };

    autoRouteToSession();
  });

  return null;
});
